//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum ContentQuality {
	Free = 70,
	Insufficient = 73,
	Paid = 80,
	Target = 84
}
